import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEbayComponent } from './simple-icons-ebay.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEbayComponent ],
    exports:      [ SimpleIconsEbayComponent ],
    bootstrap:    []
})
export class SimpleIconsEbayModule {}
